"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TectonicConst = void 0;
exports.TectonicConst = {
    API_URL: " https://api.tectonic.finance/",
    ETHER_ADDRESS: "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee",
    BLOCKS_PER_YEAR: 5256000,
    BLOCKS_PER_DAY: 14400,
    SECONDS_PER_BLOCK: 6,
    DAYS_PER_YEAR: 365,
    ETH_MANTISSA: "1000000000000000000",
    TTOKEN_DECIMALS: 8,
    APY_MIN_EVENT_DURATION: 3600,
    SECONDS_PER_YEAR: 31536000
};
//# sourceMappingURL=constant.js.map